import { BannerWarning } from 'spa/components/warnings'
import { defaultStringResources } from '../../shared/utils'
import { fetchAvailableMaintenance } from '../../reducers/maintenance'
import { fetchStringResources } from '../../action_creators/string_resources'
import { Footer } from 'spa/components/footer'
import { getSunsetModeStatus } from '../../reducers/sunset'
import { Header, HeaderMobile } from 'spa/components/header'
import { Helmet } from 'react-helmet'
import { injectIntl } from 'react-intl'
import { isMobileSelector } from '../../selectors/device'
import { Loading } from '../loading'
import { loggedInSelector } from 'spa/selectors/users'
import { seoData } from '../../shared/constants'
import { seoMessages } from '../app_wrapper/localizedMessages'
import { setLocale } from '../../action_creators/locale'
import { SubHeader } from 'spa/components/sub_header'
import { useDispatch, useSelector } from 'react-redux'
import { useQueryParameters } from '../../hooks/use_query_parameters'
import classNames from 'classnames'
import Favicon from 'react-favicon'
import icon from 'spa/images/favicon.png'
import localizedMessages from './localizedMessages'
import MobileQrPopover from '../mobile_qr/popover'
import Player from 'spa/components/player/player'
import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import styles from './styles'

const Layout = ({
  children,
  fullLayout,
  fullWidth,
  intl,
  requiredResources = defaultStringResources,
  tabTitle,
  style,
}) => {
  const dispatch = useDispatch()
  // const activePromo = useSelector(state => state.promos.activePromo);
  const locale = useSelector(state => state.locale.locale)
  const isFetching = useSelector(state => state.stringResources.isFetching)
  const isMobile = useSelector(isMobileSelector)
  const isLoggedIn = useSelector(loggedInSelector)
  const { pathname } = useSelector(state => state.router.location)
  const [{ region }] = useQueryParameters({ region: '' })

  const ref = useRef()

  useEffect(() => {
    if (!ref.current) {
      dispatch(fetchAvailableMaintenance())
      dispatch(getSunsetModeStatus())
    }
  }, [dispatch, pathname])

  useEffect(() => {
    if (!isLoggedIn && region) dispatch(setLocale(region))

    dispatch(fetchStringResources(requiredResources))
  }, [dispatch, locale, requiredResources])

  return (
    <div
      className={classNames(styles.base, {
        [styles.baseMobile]: isMobile,
      })}
      style={style}
    >
      <Favicon url={icon} />
      <Helmet defer={false}>
        <title key="pagetitle">
          {intl.formatMessage(
            seoMessages[
              `${
                seoData[
                  pathname.startsWith('/playlists') ? '/playlists' : pathname
                ]
              }Title`
            ] ||
              (localizedMessages.hasOwnProperty(tabTitle)
                ? localizedMessages[tabTitle]
                : localizedMessages.djcityTitle)
          )}
        </title>
        {isMobile ? (
          <meta
            content="width=device-width, initial-scale=1"
            key="initial-scale"
            name="viewport"
          />
        ) : (
          <meta content="maximum-scale=0" key="initial-scale" name="viewport" />
        )}
      </Helmet>
      <div className={styles.header} id="header">
        {!isFetching &&
          (isMobile ? (
            <HeaderMobile />
          ) : (
            <>
              <Header />
              <SubHeader />
            </>
          ))}

        <BannerWarning />
      </div>
      {isFetching ? (
        <Loading className={styles.loading} withHelp={true} />
      ) : (
        <div
          className={classNames({
            [styles.layoutContainerFull]: fullLayout,
            [styles.layoutContainer]: !fullLayout,
            [styles.fullWidth]: fullWidth,
          })}
          id="body"
        >
          <MobileQrPopover />
          {children}
        </div>
      )}
      {isLoggedIn && <Player />}
      {!isFetching && <Footer />}
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
  fullLayout: PropTypes.bool,
  fullWidth: PropTypes.bool,
  intl: PropTypes.object,
  requiredResources: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  tabTitle: PropTypes.string,
}

const ConnectedLayout = injectIntl(Layout)

export { ConnectedLayout as Layout }
